const getters = {
  processing: (state) => state.processing,
  data: (state) => state.data,
};

export default getters;
